import { TextField, Autocomplete } from '@mui/material';

import useDirectoryEmails from './hooks/useDirectoryEmails';

type AssigneeAutocompleteProps = {
  label: string;
  value: string;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  onChange: (email: string) => void;
};

export default function AssigneeAutocomplete({
  label,
  value,
  helperText,
  error,
  required,
  onChange,
}: AssigneeAutocompleteProps) {
  const options = useDirectoryEmails();

  return (
    <Autocomplete
      freeSolo
      size="small"
      options={options}
      value={value}
      onInputChange={(_event, next) => onChange(next)}
      renderInput={(params) => (
        <TextField {...params} label={label} error={error} helperText={helperText} required={required} />
      )}
    />
  );
}
